/// <amd-module name="SuiteCommerce.GridOrder.Confirmation.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Confirmation.View", ["require", "exports", "Backbone", "grid_order_confirmation.tpl", "SuiteCommerce.GridOrder.Configuration"], function (require, exports, Backbone_1, confirmationTemplate, GridOrder_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ConfirmationView = /** @class */ (function (_super) {
        __extends(ConfirmationView, _super);
        function ConfirmationView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = confirmationTemplate;
            _this.title = GridOrder_Configuration_1.GridOrderConfiguration.confirmationText.replace('[[items]]', String(options.quantityTotal));
            return _this;
        }
        ConfirmationView.prototype.getContext = function () {
            return {
                viewCartButtonLabel: GridOrder_Configuration_1.GridOrderConfiguration.viewCartButtonLabel,
                continueShoppingButtonLabel: GridOrder_Configuration_1.GridOrderConfiguration.continueShoppingButtonLabel,
            };
        };
        return ConfirmationView;
    }(Backbone_1.View));
    exports.ConfirmationView = ConfirmationView;
});
